<template>
    <div class="sec-cont">
        <Head :title="title"/>
        <div class="max-w-full bg-white rounded-md shadow overflow-hidden p-6">
            <form @submit.prevent="submitForm">

                <!-- Applicant Details Section -->
                <h2 class="text-xl font-bold mb-4">Applicant Details</h2>


                <div class="flex flex-wrap -mb-8 -mr-6">
                    <select-input v-model="form.salutation" :error="form.errors?.salutation"
                                  class="pb-8 pr-6 w-full lg:w-1/6" :label="__('Salutation')"
                    >
                        <option value="Mr.">{{ __('Mr.') }}</option>
                        <option value="Ms.">{{ __('Ms.') }}</option>
                        <option value="Mrs.">{{ __('Mrs.') }}</option>
                    </select-input>

                    <text-input v-model="form.name" :error="form.errors.name"
                                class="pb-8 pr-6 w-full lg:w-1/3" :label="__('Name Of Applicant')"
                    />
                    <text-input v-model="form.father_name" :error="form.errors.father_name"
                                class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Father\'s Name')"
                    />
                    <text-input v-model="form.date_of_birth" :error="form.errors.date_of_birth"
                                class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Date Of Birth')" type="date"
                                :max="currentDate"
                                @focus.native="$event.target.showPicker()"
                    />

                    <text-input v-model="form.contact_number" :error="form.errors.contact_number"
                                class="pb-8 pr-6 w-full lg:w-1/2"
                                :label="__('Contact Number')" type="number"
                    />

                    <div class="pb-8 pr-6 w-full lg:w-1/2">
                        <label class="form-label">{{ __('Marital Status') }}</label>
                        <div class="mt-2 mb-2 flex items-center">
                            <div class="mr-6">
                                <input type="radio" id="married" value="married" name="marital_status"
                                       v-model="form.marital_status"
                                       class="mr-2"
                                />
                                {{ __('Married') }}
                            </div>
                            <div>
                                <input type="radio" id="unmarried" value="unmarried" name="marital_status"
                                       v-model="form.marital_status"
                                       class="mr-2"
                                />
                                {{ __('Unmarried') }}
                            </div>
                        </div>
                        <span v-if="form.errors.marital_status" class="text-red-500">{{
                                form.errors.marital_status
                            }}</span>
                    </div>

                    <textarea-input v-model="form.current_address" :error="form.errors.current_address"
                                    class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Current Address')"
                    />
                </div>
                <!-- Qualification Details Section -->
                <div>
                    <AcademicQualifications
                        v-model="form.academic_qualifications"
                        ref="academicQualifications"
                        @add-row="addRow"
                        @save-row="saveRow"
                        @delete-row="deleteRow"
                    />
                </div>


                <!-- Other Details Section -->
                <h2 class="text-xl font-bold mt-6 mb-4">Other Details</h2>
                <div class="flex flex-wrap -mb-4 -mr-6">
                    <text-input v-model="form.schooling_name" :error="form.errors.schooling_name"
                                class="pb-8 pr-6 w-full  lg:w-1/2" :label="__('School Name')"
                    />
                    <text-input v-model="form.schooling_medium" :error="form.errors.schooling_medium"
                                class="pb-8 pr-6 w-full  lg:w-1/2" :label="__('Schooling Medium')"
                    />
                    <text-input v-model="form.favourite_subjects" :error="form.errors.favourite_subjects"
                                class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Favourite Subjects')"
                    />
                    <text-input v-model="form.teaching_class_limit" :error="form.errors.teaching_class_limit"
                                class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Up to which class can you teach?')"
                    />
                    <text-input v-model="form.reason_to_join" :error="form.errors.reason_to_join"
                                class="pb-8 pr-6 w-full lg:w-1/2"
                                :label="__('Why do you want to join Creative Brain Academy?')"
                    />
                    <text-input v-model="form.about_academy" :error="form.errors.about_academy"
                                class="pb-8 pr-6 w-full lg:w-1/2"
                                :label="__('What do you know about Creative Brain Academy?')"
                    />


                    <textarea-input v-model="form.prefer_teaching_reason" :error="form.errors.prefer_teaching_reason"
                                    class="pb-8 pr-6 w-full" :label="__('Why do you prefer teaching job?')"
                    />

                    <textarea-input v-model="form.positive_points" :error="form.errors.positive_points"
                                    class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Your Positive Points')"
                    />
                    <textarea-input v-model="form.negative_points" :error="form.errors.negative_points"
                                    class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Your Negative Points')"
                    />


                    <textarea-input v-model="form.previous_work_experience" :error="form.errors.previous_work_experience"
                                    class="pb-8 pr-6 w-full lg:w-1/2"
                                    :label="__('Your previous work experience if you have worked anywhere')"
                    />
                    <textarea-input v-model="form.leave_reason" :error="form.errors.leave_reason"
                                    class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Why did you leave the previous job?')"
                    />

                    <text-input v-model="form.salary_expectation" :error="form.errors.salary_expectation"
                                class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Your salary expectation (Nearly)')"
                    />
                    <text-input v-model="form.continue_duration" :error="form.errors.continue_duration"
                                class="pb-8 pr-6 w-full lg:w-1/2"
                                :label="__('How long will you continue in our school?')"
                    />
                    <textarea-input v-model="form.other_qualities" :error="form.errors.other_qualities"
                                    class="pb-8 pr-6 w-full lg:w-1/2"
                                    :label="__('Other Qualities (Cultural, Sports, Academics or any other)')"
                    />

                    <textarea-input v-model="form.commitments" :error="form.errors.commitments"
                                    class="pb-8 pr-6 w-full lg:w-1/2"
                                    :label="__('Your full and final commitments & promises to our school and students')"
                    />

                    <text-input v-model="form.application_date" :error="form.errors.application_date"
                                class="pb-8 pr-6 w-full lg:w-1/2"
                                type="date" :max="currentDate" :label="__('Application Date')"
                                @focus.native="$event.target.showPicker()"
                    />

                    <div class="pb-8 pr-6 w-full lg:w-1/2">
                        <SelectInput
                            label="Select Application Status"
                            id="application-status"
                            v-model="form.interview_status"
                            :error="form.errors.interview_status"
                        >

                            <option value="">{{ __('Select') }}</option>
                            <option v-for="(label, code) in interview_status_codes" :value="code" :key="code">
                                {{ label }}
                            </option>

                        </SelectInput>
                    </div>

                </div>

                <!-- Submit Button -->
                <div class="flex items-center justify-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <loading-button :loading="form.processing" class="btn-indigo mx-auto" type="submit">{{
                            __('Submit')
                        }}
                    </loading-button>
                </div>

            </form>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'
import AcademicQualifications from '@/Pages/Interview/AcademicQualifications'

export default {

        components: {
            FileInput,
            Head,
            Link,
            LoadingButton,
            SelectInput,
            TextInput,
            TextareaInput,
            AcademicQualifications
        },
        layout: Layout,

        data() {
            return {

                form: this.$inertia.form( {
                    salutation: '',
                    name: '',
                    father_name: '',
                    date_of_birth: '',
                    current_address: '',
                    contact_number: '',
                    marital_status: [],
                    academic_qualifications: [],
                    other_qualities: '',
                    schooling_medium: '',
                    schooling_name: '',
                    favourite_subjects: '',
                    teaching_class_limit: '',
                    prefer_teaching_reason: '',
                    reason_to_join: '',
                    positive_points: '',
                    negative_points: '',
                    commitments: '',
                    about_academy: '',
                    previous_work_experience: '',
                    leave_reason: '',
                    salary_expectation: '',
                    continue_duration: '',
                    application_date: '',
                    interview_status: '',
                    errors: {},
                    processing: false
                }),
                interview_status_codes: {
                    1: 'Yes',
                    2: 'Waiting',    // Previously 'Waiting'
                    3: 'Reject',
                },
                currentDate: new Date().toISOString().split('T')[0], // to set the max date
            }
        },
    methods: {

        validateForm() {
            this.form.errors = {} // Reset errors

            if (!this.form.salutation) this.form.errors.salutation = 'Salutation name is required'
            if (!this.form.name) this.form.errors.name = 'Applicant name is required'
            if (!this.form.father_name) this.form.errors.father_name = 'Father name is required'
            if (!this.form.date_of_birth) this.form.errors.date_of_birth = 'Date of birth is required'
            if (!this.form.contact_number) {
                this.form.errors.contact_number = 'Contact number is required'
            } else if (!/^\d{10}$/.test(this.form.contact_number)) {
                this.form.errors.contact_number = 'Contact number must be 10 digits'
            }

            if (this.form.marital_status.length <= 0) {
                this.form.errors.marital_status = 'Marital status is required'
            }
            if (!this.form.current_address) this.form.errors.current_address = 'Current address is required'

            const academicQualificationsComponent = this.$refs.academicQualifications

            // Validate the academic qualifications
            academicQualificationsComponent.validateRows()

            if (!this.form.schooling_name) this.form.errors.schooling_name = 'Schooling name is required'
            if (!this.form.schooling_medium) this.form.errors.schooling_medium = 'Schooling medium is required'
            if (!this.form.favourite_subjects) this.form.errors.favourite_subjects = 'Favourite subjects is required'
            if (!this.form.teaching_class_limit) this.form.errors.teaching_class_limit = 'Teaching class limit is required'
            if (!this.form.reason_to_join) this.form.errors.reason_to_join = 'Current address is required'
            if (!this.form.about_academy) this.form.errors.about_academy = 'Current address is required'
            if (!this.form.prefer_teaching_reason) this.form.errors.prefer_teaching_reason = 'Current address is required'
            if (!this.form.positive_points) this.form.errors.positive_points = 'Current address is required'
            if (!this.form.negative_points) this.form.errors.negative_points = 'Current address is required'
            if (!this.form.previous_work_experience) this.form.errors.previous_work_experience = 'Current address is required'
            if (!this.form.leave_reason) this.form.errors.leave_reason = 'Leave reason is required'
            if (!this.form.salary_expectation) this.form.errors.salary_expectation = 'Salary expectation is required'
            if (!this.form.continue_duration) this.form.errors.continue_duration = 'Duration is required'
            if (!this.form.other_qualities) this.form.errors.other_qualities = 'Other qualities is required'
            if (!this.form.commitments) this.form.errors.commitments = 'Commitments is required'
            if (!this.form.application_date) this.form.errors.application_date = 'Application date is required'
            if (!this.form.interview_status) this.form.errors.interview_status = 'Application status is required'

            return Object.keys(this.form.errors).length === 0
        },

        submitForm() {
            if (this.validateForm()) {
                this.form.processing = true
                this.form.post(this.route('admin.storeInterviewData'), {
                    onSuccess: () => {
                        this.form.reset();
                        this.$refs.academicQualifications.resetRows();
                    }
                })
            }
        },
    },
}
</script>
